import { CardController } from './card.controller';
import template from './card.html';

export const cardComponent = {
  name: 'card',
  restrict: 'E',
  template,
  controller: CardController,
  controllerAs: 'vm',
  bindings: {
    card: '<'
  }
};
